module.exports = __webpack_public_path__ + "static/media/road-solid.c28ea4c0.svg";